import styles from './LightButtonComponent.module.css'

const LightButtonComponent = ({children, onClick, style, disabled, useOnClick = false}) => {

    return (
        <button className={styles.component} style={style} disabled={disabled}
            onMouseDown={(event) => {
                if(!useOnClick){
                    event.stopPropagation()
                    onClick()
                }
            }}
            onClick={(event) => {
                if(useOnClick){
                    event.stopPropagation()
                    onClick()
                }
            }}
        >
            {children}
        </button>
    );

}

export default LightButtonComponent;